/*
 * 產品頁揀款：有依賴嘅選項（sections/main-product.liquid variant_picker：第一個選項係「尺寸」又有「功能」先載，
 * 即係 I301 / I303 / I307 / I401 / I402 / Brooks / Fububu 呢類）
 *
 *   尺寸 → 物料 → 功能，後面嘅選項跟前面揀咗咩：
 *   - 前面一改，後面揀咗嘅值變咗冇呢個組合 → 自動換做有貨嘅（同 Shopify 冇呢個 variant 嘅「無法供應」比，客唔會卡住）
 *   - 某個值淨係其他尺寸先有（例如 I402「梳化床＋貴妃」只有 201cm、I401 只有 196cm / 254cm）：
 *       以前：disabled + 刪除線，撳極都冇反應，客以為冇貨（I402 一星期 1,600 個產品頁 session，0 個加入購物車）
 *       而家：照撳得，掣入面細字「只有 201cm」；撳落去自動轉 201cm，下面出一行「已幫你轉做 201cm（梳化床＋貴妃只有 201cm）」
 *     根本冇任何 variant 用嘅值先 disabled（照舊刪除線）。下拉選單（variant-selects）照舊 disabled。
 *
 *   ImOptionGroups（純函數，tests/option-picker.cjs 測）：
 *     allowedAt(variants, selection, index)       → 跟前面揀咗嘅，第 index 個選項有邊啲值
 *     needsFor(variants, selection, index, value) → { group, values }：要轉邊個選項、轉做邊啲值先有呢個 value；有就 null
 *     bestFor(variants, selection, index, value)  → 揀咗 value 之後最貼近而家揀法嘅 variant（有貨先、再平先）
 */
(function (root) {
  function matchesPrefix(variant, selection, upTo) {
    for (var j = 0; j < upTo; j++) {
      if (variant.options[j] !== selection[j]) return false;
    }
    return true;
  }

  function allowedAt(variants, selection, index) {
    var allowed = {};
    variants.forEach(function (v) {
      if (matchesPrefix(v, selection, index)) allowed[v.options[index]] = true;
    });
    return allowed;
  }

  function needsFor(variants, selection, index, value) {
    var having = variants.filter(function (v) { return v.options[index] === value; });
    if (!having.length) return null;
    for (var j = 0; j < index; j++) {
      var ok = having.some(function (v) { return matchesPrefix(v, selection, j + 1); });
      if (ok) continue;
      var values = [];
      having.forEach(function (v) {
        if (matchesPrefix(v, selection, j) && values.indexOf(v.options[j]) === -1) values.push(v.options[j]);
      });
      return { group: j, values: values };
    }
    return null;
  }

  function bestFor(variants, selection, index, value) {
    var best = null;
    var bestScore = -1;
    variants.forEach(function (v) {
      if (v.options[index] !== value) return;
      var score = 0;
      for (var j = 0; j < selection.length; j++) {
        if (j !== index && v.options[j] === selection[j]) score += 2;
      }
      if (v.available) score += 1;
      if (score > bestScore || (score === bestScore && best && v.price < best.price)) {
        best = v;
        bestScore = score;
      }
    });
    return best;
  }

  root.ImOptionGroups = { allowedAt: allowedAt, needsFor: needsFor, bestFor: bestFor };
})(typeof window !== 'undefined' ? window : this);

(function () {
  if (typeof document === 'undefined') return;
  var G = window.ImOptionGroups;

  function initialize(root) {
    root.querySelectorAll('[data-im-option-groups]').forEach(function (picker) {
      if (picker.dataset.imOptionsReady) return;
      var data = picker.querySelector('script[type="application/json"]');
      if (!data) return;
      var variants = JSON.parse(data.textContent);
      var radios = picker.matches('variant-radios');
      var groups = radios
        ? Array.from(picker.querySelectorAll('fieldset'), function (fieldset) {
            return {
              values: Array.from(fieldset.querySelectorAll('input[type="radio"]')),
              selected: function () { var c = fieldset.querySelector('input:checked'); return c ? c.value : undefined; },
              choose: function (value) { fieldset.querySelectorAll('input').forEach(function (input) { input.checked = input.value === value; }); }
            };
          })
        : Array.from(picker.querySelectorAll('select'), function (select) {
            return {
              values: Array.from(select.options),
              selected: function () { return select.value; },
              choose: function (value) { select.value = value; }
            };
          });
      var note = null;

      function selection() { return groups.map(function (g) { return g.selected(); }); }

      function setNeeds(input, text) {
        var label = input.nextElementSibling;
        if (!label || label.tagName !== 'LABEL') return;
        var hint = label.querySelector('.im-opt-needs');
        label.classList.toggle('im-opt--needs', !!text);
        if (!text) { if (hint) hint.remove(); return; }
        if (!hint) {
          hint = document.createElement('span');
          hint.className = 'im-opt-needs';
          label.appendChild(hint);
        }
        hint.textContent = text;
      }

      function showNote(text) {
        if (!note) {
          note = document.createElement('p');
          note.className = 'im-opt-note';
          note.setAttribute('role', 'status');
          picker.insertAdjacentElement('afterend', note);
        }
        note.textContent = text;
        note.hidden = !text;
      }

      function sync(resolveMissing) {
        var candidates = variants;
        groups.forEach(function (group, index) {
          var allowed = {};
          candidates.forEach(function (v) { allowed[v.options[index]] = true; });
          var current = selection();
          group.values.forEach(function (input) {
            if (!radios) { input.disabled = !allowed[input.value]; return; }
            var exists = variants.some(function (v) { return v.options[index] === input.value; });
            input.disabled = !exists;
            var needs = exists && !allowed[input.value] ? G.needsFor(variants, current, index, input.value) : null;
            setNeeds(input, needs ? '只有 ' + needs.values.join('／') : '');
          });
          if (resolveMissing && !allowed[group.selected()] && candidates.length) {
            var next = candidates.find(function (v) { return v.available; }) || candidates[0];
            group.choose(next.options[index]);
          }
          var picked = group.selected();
          candidates = candidates.filter(function (v) { return v.options[index] === picked; });
        });
      }

      // capture：喺 Dawn VariantRadios 讀選項之前先搞掂依賴
      picker.addEventListener('change', function (event) {
        var input = event.target;
        if (!input.matches('input[type="radio"], select')) return;
        var text = '';
        if (radios) {
          var index = groups.findIndex(function (g) { return g.values.indexOf(input) > -1; });
          var current = selection();
          var needs = index > 0 ? G.needsFor(variants, current, index, input.value) : null;
          if (needs) {
            var best = G.bestFor(variants, current, index, input.value);
            if (best) {
              var changed = [];
              groups.forEach(function (g, j) {
                if (j < index && best.options[j] !== current[j]) {
                  g.choose(best.options[j]);
                  changed.push(best.options[j]);
                }
              });
              if (changed.length) {
                text = '已幫你轉做 ' + changed.join('、') + '（' + input.value + ' 只有 ' + needs.values.join('／') + '）';
              }
            }
          }
        }
        showNote(text);
        sync(true);
      }, true);
      picker.dataset.imOptionsReady = 'true';
      sync(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
